/**
 * Defensive localStorage wrappers. The widget runs inside customer pages
 * where localStorage may be disabled (incognito, sandboxed iframe,
 * Safari's "Block all cookies"). Every call goes through `testLocalStorage`
 * once and short-circuits when storage isn't usable.
 */
let cached = null

export function testLocalStorage() {
  if (cached !== null) return cached
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    cached = false
    return cached
  }
  try {
    const probe = '__ometrics_probe__'
    localStorage.setItem(probe, probe)
    localStorage.removeItem(probe)
    cached = true
  } catch {
    cached = false
  }
  return cached
}

export function readJson(key, fallback = null) {
  if (!testLocalStorage()) return fallback
  try {
    const raw = localStorage.getItem(key)
    return raw == null ? fallback : JSON.parse(raw)
  } catch {
    return fallback
  }
}

export function writeJson(key, value) {
  if (!testLocalStorage()) return false
  try {
    localStorage.setItem(key, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}

export function readString(key, fallback = '') {
  if (!testLocalStorage()) return fallback
  try {
    const raw = localStorage.getItem(key)
    return raw == null ? fallback : raw
  } catch {
    return fallback
  }
}

export function writeString(key, value) {
  if (!testLocalStorage()) return false
  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export function removeKey(key) {
  if (!testLocalStorage()) return
  try {
    localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
